'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = getCookie;
exports.setCookie = setCookie;
exports.deleteCookie = deleteCookie;
exports.isSafari = isSafari;
exports.parseJSON = parseJSON;
function isServer() {
  return typeof window === 'undefined';
}

function getCookie(cname) {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

function setCookie(cname, cvalue, exdays, cdomain) {
  var now = new Date();
  now.setTime(now.getTime() + exdays * 24 * 60 * 60e3);
  var expires = 'expires=' + now.toUTCString();
  var domain = cdomain ? 'domain=' + cdomain + ';' : '';
  var secure = domain ? 'secure;' : '';
  document.cookie = cname + '=' + cvalue + ';' + domain + secure + expires + ';path=/';
}

function deleteCookie(cname, cdomain) {
  setCookie(cname, null, -1, cdomain);
}

function isSafari() {
  return navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
}

function parseJSON(json) {
  try {
    return json !== '' ? JSON.parse(json) : '';
  } catch (error) {
    return json;
  }
}

var setSessionStorage = exports.setSessionStorage = function setSessionStorage(key, value) {
  try {
    var valueParsed = value;
    if (typeof value !== 'string') {
      valueParsed = JSON.stringify(value);
    }

    window.sessionStorage.setItem(key, valueParsed);
  } catch (error) {
    throw new Error('Não foi possível escrever em sessionStorage');
  }
};

var getSessionStorage = exports.getSessionStorage = function getSessionStorage(key) {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    throw new Error('Não foi possível ler item em sessionStorage');
  }
};

var deleteSessionStorage = exports.deleteSessionStorage = function deleteSessionStorage(key) {
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    throw new Error('Não foi possível remover o item em sessionStorage');
  }
};

var getDomain = exports.getDomain = function getDomain(host) {
  if (isServer()) {
    return null;
  }

  host = host || document.domain;

  var firstTLDs = ['dev', 'br'];
  var secondTLDs = ['com'];

  var domain = host.replace(/^www\./, '');

  var parts = domain.split('.');

  while (parts.length > 3) {
    parts.shift();
  }

  if (parts.length === 3 && (parts[1].length > 2 && parts[2].length > 2 || secondTLDs.indexOf(parts[1]) === -1 && firstTLDs.indexOf(parts[2]) === -1)) {
    parts.shift();
  }

  return parts.join('.');
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/bifrost/build/utils.js
// module id = 20
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38